import { TImageOrientation, TTypeOfErrorModalWindow, TTypeOfModalWindow } from './formImageUploaderContext';

export enum FormImageUploaderActionTypes {
	SET_IMAGE_ORIENTATION = 'SET_IMAGE_ORIENTATION',
	SET_LOADING = 'SET_LOADING',
	SET_FULL_SIZE_SRC = 'SET_FULL_SIZE_SRC',
	SET_CROPPED_SIZE_SRC = 'SET_CROPPED_SIZE_SRC',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_TYPE_OF_ERROR_MODAL_WINDOW = 'CHANGE_TYPE_OF_ERROR_MODAL_WINDOW',
	SET_LOADING_IMAGE_ERROR = 'SET_LOADING_IMAGE_ERROR',
}

interface ISetImageOrientation {
	type: FormImageUploaderActionTypes.SET_IMAGE_ORIENTATION;
	payload: {
		imageOrientation: TImageOrientation;
	};
}

interface ISetLoading {
	type: FormImageUploaderActionTypes.SET_LOADING;
	payload: {
		isLoading: boolean;
	};
}

interface ISetFullSizeSrc {
	type: FormImageUploaderActionTypes.SET_FULL_SIZE_SRC;
	payload: {
		src: string | null;
	};
}

interface ISetCroppedSizeSrc {
	type: FormImageUploaderActionTypes.SET_CROPPED_SIZE_SRC;
	payload: {
		src: string | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: FormImageUploaderActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IChangeTypeOfErrorModalWindow {
	type: FormImageUploaderActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW;
	payload: {
		typeOfErrorModalWindow: TTypeOfErrorModalWindow;
	};
}

interface ISetLoadingImageError {
	type: FormImageUploaderActionTypes.SET_LOADING_IMAGE_ERROR;
	payload: {
		loadingImageError: boolean;
	};
}

export type TFormImageUploaderAction =
	| ISetImageOrientation
	| ISetLoading
	| ISetFullSizeSrc
	| ISetCroppedSizeSrc
	| IChangeTypeOfModalWindow
	| IChangeTypeOfErrorModalWindow
	| ISetLoadingImageError;
